import { prefixerC } from '.'

export const ROUTE_DESTINATARIOS = prefixerC('destinatarios')
export const ROUTE_JEFE_BODEGA = prefixerC('jefe-bodega')
export const ROUTE_NIVEL_APROBACION_ORDEN_PEDIDO = prefixerC('nivel-aprobacion-orden-pedido')
export const ROUTE_PERMISOS_BODEGA = prefixerC('permisos-bodega')
export const ROUTE_POLITICA_ITEM = prefixerC('politica-item')
export const ROUTE_STOCK_MINIMO = prefixerC('stock-minimo')
